import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PCTableComponent } from '../pctable/pctable.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild } from '@angular/core';
import { Field } from '../../models/entity-defin';
import { PCTableOutputModel } from '../../models/pc-table-input-model';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-pcsetting-modal',
  templateUrl: './pcsetting-modal.component.html',
  styleUrls: ['./pcsetting-modal.component.css']
})
export class PcsettingModalComponent {
  constructor(
    private modalService: NgbModal,
    private logger: LoggerService
  ) {
  }

  @Output() parentAction = new EventEmitter<PCTableOutputModel>();
  @Input() fields?: Field[];
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;
  @ViewChild('settingsModal') settingsModal!: any;

  public SubmitSetting() {
    this.callParent("SubmitSetting", this.fields);
    this.modalService.dismissAll();
  }

  public callParent(action: string, data: any) {
    this.parentAction.next(new PCTableOutputModel(action, data));
  }

  public openSettingModal() {
    try {
      this.modalService
        .open(this.settingsModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
          },
          (reason) => { }
        );
    } catch (error) {
      this.logger.addException(error, false);
    }
  }


}